import { initImageInspirationSlider } from './ImageInspirationSliderShared.js';

document.addEventListener('DOMContentLoaded', function () {
  const sliders = Array.from(
    document.querySelectorAll('.imageInspirationSlider:not(.imageInspirationSlider--embedded) > .slider')
  );

  sliders.forEach((slider) => {
    initImageInspirationSlider(slider);
  });
});
